var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCebabeMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1058_14031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5625 13.7754C13.4254 13.7754 14.125 13.0758 14.125 12.2129C14.125 11.3499 13.4254 10.6504 12.5625 10.6504C11.6996 10.6504 11 11.3499 11 12.2129C11 13.0758 11.6996 13.7754 12.5625 13.7754Z",
    fill: "#535353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5625 6.65039C13.4254 6.65039 14.125 5.95084 14.125 5.08789C14.125 4.22495 13.4254 3.52539 12.5625 3.52539C11.6996 3.52539 11 4.22495 11 5.08789C11 5.95084 11.6996 6.65039 12.5625 6.65039Z",
    fill: "#535353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5625 20.9004C13.4254 20.9004 14.125 20.2008 14.125 19.3379C14.125 18.4749 13.4254 17.7754 12.5625 17.7754C11.6996 17.7754 11 18.4749 11 19.3379C11 20.2008 11.6996 20.9004 12.5625 20.9004Z",
    fill: "#535353"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1058_14031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.0253906)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCebabeMenuIcon);
export default __webpack_public_path__ + "static/media/cebabe_menu_icon.b645af346632161b06ba8159d75a4d2d.svg";
export { ForwardRef as ReactComponent };